import { Link } from "react-router-dom";

export default function NotFound() {
  return (
    <div className="flex min-h-[70vh] items-center justify-center px-4">
      <div className="aa-glass-card flex w-full max-w-xl flex-col items-center gap-4 rounded-3xl p-8 text-center text-foreground/80">
        <p className="text-xs uppercase tracking-wide text-muted-foreground">404</p>
        <h1 className="aa-page-title text-3xl font-semibold">
          <span className="aa-gradient-text">Page not found</span>
        </h1>
        <p className="max-w-md text-sm text-muted-foreground">
          This page doesn&apos;t exist or you don&apos;t have access to it. Check the URL or head back to Home.
        </p>
        <Link to="/dashboard" className="text-sm text-primary hover:text-foreground">
          Back to Home
        </Link>
      </div>
    </div>
  );
}
